PJQ.views.signatures = {};
PJQ.views.signatures.SignatureSubmitModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Signature-Submit'),
        headerText: 'Sign Below',
        headerSubText: '',
        fetchSignature: true
    },
    events: {
        'click .signature-erase': 'onErase',
        'click .signature-close': 'onClose',
        'click .signature-submit': 'onSubmit'
    },
    afterRender: function () {
        this.$canvas = this.$('.signature-canvas');
        this.canvas = this.$canvas[0];
        this.renderSignaturePad();

        if(this.options.fetchSignature) {
            this.fetchUserSignature();
        }
        else{
            let signature = this.options.signature;
            this.isNewSignature = true;

            if(signature){
                this.signaturePad.fromDataURL(signature);
            }
        }
    },
    renderData: function () {
        return {
            options: this.options
        }
    },
    renderSignaturePad: function () {
        if (this.signaturePad != null) {
            this.signaturePad.off();
        }

        this.signaturePad = new SignaturePad(this.canvas);
        this.signaturePad.minWidth = 1;
        this.signaturePad.maxWidth = 1;
        this.resizeCanvas();
    },
    onSubmit: function () {
        new PJQ.Loader(this.$('.modal-content'));
        if (this.options.onSubmit && !this.isSubmitted) {
            this.isSubmitted = true;
            this.options.onSubmit(this.isNewSignature ? this.signaturePad.toDataURL() : null, _.bind(function () {
                this.removeModal();
            }, this));
        }
    },
    onClose: function () {
        if (this.options.onClose) {
            this.options.onClose(this.model);
        }
    },
    onErase: function () {
        this.isNewSignature = true;
        this.renderSignaturePad();
    },
    resizeCanvas: function () {
        let ratio = Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
    },
    fetchUserSignature: function () {
        this.signaturePad.off();
        this.signaturePad.fromDataURL(PJQ.helpers.urlHelpers.buildAPIURL('/users/signature', false, true));
        new PJQ.ajax.Request({
            endpoint: "/users/signature"
        }).get().done(_.bind(function () {
            //If it gets here at all, that means the user doesnt have a signature
            //jQuery ajax will not call done on requests for files
            this.isNewSignature = true;
            this.signaturePad.on();
        }, this));
    }
});

PJQ.views.signatures.SignatureTermsModal = PJQ.views.signatures.SignatureSubmitModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Signature-Terms'),
        maxWidth: '1200px',
        fitHeight: true
    },
    beforeRender: function () {
        this.renderData = {
            terms: this.options.terms
        }
    }
});